import { useVerify } from '@entities/Authentication/model.ts';
import type { VerificationType } from '@entities/Authentication/types.ts';
import { useCallback, useEffect, useState } from 'react';
import { useCaptchaModal } from '@pages/personal/client/editor-page/Modals/CaptchaVerificationModal/model.ts';
import { usePlatformSettings } from '@shared/hooks/index.ts';
import { CommonButton, MediumHeader } from '@shared/ui/index.ts';
import { ModalMiddle } from '@src/library/components/common/index.ts';
import { Captcha } from '@src/modules/Authentication/Captcha/index.tsx';
import { ModalError } from '@src/modules/Authentication/frames/modal-error/index.tsx';
import * as shared from '../styles.module.scss';

type PT = {};
const getTitle = (verification_type: VerificationType) => {
  switch (verification_type) {
    case 'reset_email': {
      return 'Изменение адреса электронной почты';
    }
    case 'reset_phone': {
      return 'Подтвердите номер телефона';
    }
    default: {
      return undefined;
    }
  }
};
export const CaptchaVerificationModal = ({}: PT) => {
  const { closeCaptchaModal, state } = useCaptchaModal();
  const { isVerificationLoading, onVerificationButtonClick } = useVerify();

  const { first_method, grecaptcha_enabled, cf_turnstile_enabled, yandex_captcha_enabled } =
    usePlatformSettings();
  const [error, setError] = useState('');
  const [captcha, setCaptcha] = useState('');
  const methodsToSend = first_method;
  const onReadyButtonClick = useCallback(async () => {
    await onVerificationButtonClick({
      verification_type: state.verification_type,
      type: state.type || methodsToSend,
      captcha,
      email: state?.email,
      phonenumber: state?.phonenumber,
      onError: setError,
      onSuccess: () => {
        setCaptcha('');
        closeCaptchaModal({ isSuccess: true, captcha: captcha });
      },
    });
  }, [state, closeCaptchaModal, onVerificationButtonClick, captcha, methodsToSend, setError]);

  useEffect(() => {
    if (!grecaptcha_enabled && !cf_turnstile_enabled && !yandex_captcha_enabled && state?.isOpen) {
      onReadyButtonClick();
    }
  }, [grecaptcha_enabled, cf_turnstile_enabled, yandex_captcha_enabled, state]);

  return (
    <ModalMiddle isOpen={state?.isOpen} className={shared.modal}>
      <MediumHeader
        middleClassName={shared.title}
        onClose={() => {
          closeCaptchaModal({ isSuccess: false });
          setError('');
          setCaptcha('');
        }}
        title={getTitle(state?.verification_type)}
      />
      <form className={shared.form}>
        <Captcha
          className={shared.captcha}
          onChange={(token) => {
            token && setCaptcha(token);
            setError('');
          }}
        />
        {error ? (
          <ModalError className={shared.error} error={error} />
        ) : (
          captcha && (
            <CommonButton
              className={shared.button}
              type={'button'}
              onClick={onReadyButtonClick}
              disabled={isVerificationLoading}
            >
              Готово
            </CommonButton>
          )
        )}
      </form>
    </ModalMiddle>
  );
};
